<template lang="pug">
BlueSearch
  template(#results="{}")
    .app-utility
      .page-heading
        h1.title.center Search results
    SearchResults
</template>

<script>
export default {
  name: "MultisiteSearchApp"
};
</script>

<style lang="scss" scoped>
#bluesearch::v-deep {
  .search {
    &__layout {
      display: block;
    }

    &__main {
      margin-top: 23px;

      .app-utility {
        .page-heading {
          .title {
            font-size: 27px;
          }
        }
      }
    }

    &__results {
      padding-left: 40px;
	  .search-result{
        &__date{
          display: none;
        }
        &__summary{
          display: none;
        }
      }
    }

    &__footer {
      display: flex;
      align-items: center;
    }

    &-query__submit {
      color: #ffffff;
      background-color: #2196f3;

      span {
        position: relative;
        top: 1px;
        display: inline-block;
        font-family: "Glyphicons Halflings";
        font-style: normal;
        font-weight: normal;
        line-height: 1;
        -webkit-font-smoothing: antialiased;
      }
    }
  }
}
</style>